import { MediaSummaryApi } from '../../../api/contentLibrary/models/content-library-media.api.model';
import { BaseModel } from '../../../Common/Basic/models/base.model';

export class MediaSummaryModel extends BaseModel<MediaSummaryModel, MediaSummaryApi> {
    // uses any because the id is returned as uuid from the api
    id: any;
    name: string;
    mimeType: string;
    size: number;
    approvedByUserIds: number[] = [];
    libraryIds: number[];
    url: string;
    createdDate: number;
    createdByUserId: number;
    // front-end only
    isSelected: boolean;

    constructor(apiModel?: MediaSummaryApi) {
        super();
        if (apiModel) {
            this.id = apiModel.id;
            this.name = apiModel.name;
            this.mimeType = apiModel.mimeType;
            this.size = apiModel.size;
            this.approvedByUserIds = apiModel.approvedByUserIds || [];
            this.libraryIds = apiModel.libraryIds;
            this.url = apiModel.url;
            this.createdDate = +new Date(apiModel.createdDate);
            this.createdByUserId = apiModel.createdUserId;
        }
    }

    toApiModel(): MediaSummaryApi {
        return {
            id: this.id,
            name: this.name,
            mimeType: this.mimeType,
            size: this.size,
            approvedByUserIds: this.approvedByUserIds,
            libraryIds: this.libraryIds,
            url: this.url
        };
    }

    clone(): MediaSummaryModel {
        return new MediaSummaryModel(this.toApiModel());
    }

    equals(other?: MediaSummaryModel): boolean {
        return JSON.stringify(this.toApiModel()) === JSON.stringify(other.toApiModel());
    }

    constructFromApiModel(apiModel: MediaSummaryApi): void {
        this.id = apiModel.id;
        this.name = apiModel.name;
        this.mimeType = apiModel.mimeType;
        this.size = apiModel.size;
        this.approvedByUserIds = apiModel.approvedByUserIds;
        this.libraryIds = apiModel.libraryIds;
        this.url = apiModel.url;
    }

    constructDefault(): void {
        this.id = null;
        this.name = null;
        this.mimeType = null;
        this.size = null;
        this.approvedByUserIds = null;
        this.libraryIds = null;
        this.url = null;
    }
}
